(function () {
  function getKlaviyoCompanyId() {
    var script = document.querySelector('script[src*="static.klaviyo.com/onsite/js"][src*="company_id="]');
    if (!script) return null;
    var match = script.src.match(/company_id=([^&]+)/);
    return match ? match[1] : null;
  }

  var initNewsletterSignup = function (section) {
    var wrapper = section.querySelector('[data-newsletter-signup-form]');
    if (!wrapper) return;

    var form = wrapper.querySelector('form');
    var input = form.querySelector('input[type="email"]');
    var errorEl = form.querySelector('[data-newsletter-signup-error]');
    var submitButton = form.querySelector('button[type="submit"]');
    var modal = document.getElementById(wrapper.dataset.modalId);
    var listId = wrapper.dataset.klaviyoListId;
    var errorMessage = errorEl ? errorEl.dataset.errorMessage : 'Something went wrong. Please try again.';

    function setError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    function setLoading(isLoading) {
      if (submitButton) submitButton.disabled = isLoading;
      form.classList.toggle('newsletter-signup__form--loading', isLoading);
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      setError(null);

      var email = input.value.trim();
      if (!email) return;

      var companyId = getKlaviyoCompanyId();
      if (!companyId || !listId) {
        setError(errorMessage);
        return;
      }

      setLoading(true);

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + companyId, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-10-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email },
                },
              },
            },
            relationships: {
              list: {
                data: { type: 'list', id: listId },
              },
            },
          },
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo subscription failed: ' + response.status);
          form.reset();
          if (modal) modal.show(submitButton);
        })
        .catch(function () {
          setError(errorMessage);
        })
        .finally(function () {
          setLoading(false);
        });
    });
  };

  initNewsletterSignup(document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', function (event) {
    initNewsletterSignup(event.target);
  });
})();
